import type { LangMap } from "./index";

export const visuals: LangMap = {
  it: {
    presentation: {
      writeTopicError: "Scrivi l'argomento della presentazione",
      generationFailed: "Generazione fallita",
      analysisFailed: "Analisi fallita",
      micUnavailable: "Microfono non disponibile",
      genericError: "Errore",
      createTitle: "Crea una presentazione",
      topicLabel: "Argomento",
      topicPlaceholder: "Es. La Rivoluzione francese",
      sourceLabel: "Materiale di partenza (facoltativo)",
      sourcePlaceholder: "Incolla appunti o testo da usare come fonte",
      contextLabel: "Contesto",
      contextSchool: "Scuola",
      contextUniversity: "Università",
      contextExam: "Esame orale",
      contextMeeting: "Riunione",
      styleLabel: "Stile",
      styleMinimal: "Minimal",
      styleNotebook: "Quaderno",
      styleAcademic: "Accademico",
      styleVisual: "Visuale",
      styleDark: "Scuro",
      durationLabel: "Durata: {{minutes}} minuti",
      extraLabel: "Richieste extra (facoltativo)",
      extraPlaceholder: "Es. includi una linea del tempo",
      creatingSlides: "Sto creando le slide...",
      generateButton: "Genera presentazione",
      slideCount: "{{count}} slide · ~{{minutes}} min",
      newButton: "Nuova",
      slideCounter: "Slide {{current}}/{{total}}",
      visualLabel: "Visual: {{visual}}",
      prevSlide: "Slide precedente",
      nextSlide: "Slide successiva",
      speakSeconds: "{{seconds}}s di parlato",
      whatToSay: "Cosa dire",
      hide: "Nascondi",
      show: "Mostra",
      helpExposeTitle: "Aiutami a esporla",
      helpExposeDesc: "Registra come esporresti questa slide: ti dico cosa manca e come migliorare.",
      analyzing: "Analizzo...",
      stopAndAnalyze: "Ferma e analizza",
      recordExposition: "Registra l'esposizione",
      score: "Punteggio: {{score}}/100",
      good: "Bene",
      missing: "Ti è sfuggito",
      howToImprove: "Come migliorare",
      profQuestionsTitle: "Domande del prof",
      simulateQuestions: "Simula le domande",
      answerPlaceholder: "La tua risposta...",
      evaluate: "Valuta",
      modelAnswer: "Risposta modello: {{answer}}",
    },
    illustrated: {
      genTab: "Genera",
      togetherTab: "Creiamola insieme",
      learnTab: "Imparare",
      readFileError: "Impossibile leggere il file",
      loginToSave: "Devi accedere per salvare",
      mapSaved: "Mappa salvata nella libreria",
      save: "Salva",
      styleHandDrawnLabel: "Disegnata a mano",
      styleHandDrawnHint: "Sketchnote con tanti disegni",
      styleNotebookLabel: "Quaderno",
      styleNotebookHint: "Foglio a righe, scrittura a mano",
      styleColorfulLabel: "Colorata",
      styleColorfulHint: "Rami colorati, molte icone",
      styleVisualLabel: "Super visuale",
      styleVisualHint: "Poche parole, tanti simboli",
      styleKeywordsLabel: "Parole chiave",
      styleKeywordsHint: "Solo keyword essenziali",
      styleDsaLabel: "DSA / verifica",
      styleDsaHint: "Massima leggibilità, solo l'essenziale",
      styleMinimalLabel: "Minimal",
      styleMinimalHint: "Pulita e sobria",
      styleCleanLabel: "Ordinata",
      styleCleanHint: "Chiara con qualche disegno",
      mapPending: "Mappa illustrata pronta",
      materialUploaded: "Materiale caricato",
      illustratedMapTitle: "Mappa illustrata",
      illustratedMapDesc: "Stile sketchnote: l'IA sceglie un piccolo disegno per ogni concetto che vale la pena ricordare. Puoi modificare testi, colori, simboli e spostare i rami.",
      topicLabel: "Argomento",
      topicPlaceholder: "Es. La rivoluzione francese",
      styleLabel: "Stile",
      materialOptionalLabel: "Materiale (opzionale)",
      materialPlaceholder: "Incolla appunti o un capitolo…",
      textFile: "File testo",
      audioLesson: "Audio lezione",
      photoNotes: "Foto appunti",
      specialRequestLabel: "Richiesta particolare (opzionale)",
      specialRequestPlaceholder: "Es. solo le cause, con disegni per le date",
      createIllustratedMap: "Crea mappa illustrata",
      askAiEdit: "Chiedi una modifica all'IA",
      askAiEditPlaceholder: "Es. aggiungi un ramo sulle conseguenze",
      symbolHelperTitle: "Che disegno faccio per…?",
      symbolHelperDesc: "Scrivi un concetto: l'IA propone i simboli più efficaci e spiega perché.",
      conceptPlaceholder: "Es. inflazione",
      guidedTitle: "Creiamola insieme",
      guidedDesc: "Non ti do la mappa già fatta: ti guido con una domanda alla volta finché la costruisci tu. Alla fine la trovi disegnata e modificabile.",
      guidedTopicPlaceholder: "Di cosa parliamo?",
      guidedStart: "Iniziamo",
      preparingFirstQuestion: "Preparo la prima domanda…",
      stepLabel: "Passo {{step}}",
      hintLabel: "Suggerimento: {{hint}}",
      yourAnswerPlaceholder: "La tua risposta…",
      next: "Avanti",
      lessonEyebrow: "Imparare ad imparare",
      lessonTitle: "Come si costruisce una mappa visuale",
      lessonDesc: "7 regole da applicare in ordine. Provale sulla prossima mappa che crei.",
      lesson1Title: "1. Una sola idea al centro",
      lesson1Body: "Scrivi al centro l'argomento in 2-3 parole e disegnaci un simbolo. Il cervello ricorda molto meglio se ogni concetto ha un'immagine attaccata.",
      lesson2Title: "2. Rami = grandi domande",
      lesson2Body: "Ogni ramo risponde a una domanda: cosa? perché? quando? conseguenze? Massimo 4-6 rami, altrimenti diventa una lista.",
      lesson3Title: "3. Parole chiave, non frasi",
      lesson3Body: "Una o due parole per nodo. Se hai bisogno di una frase, quella frase va detta a voce quando ripeti, non scritta.",
      lesson4Title: "4. Disegna il significato",
      lesson4Body: "Non serve saper disegnare: un cuore, una corona, una freccia bastano. Il simbolo deve rappresentare il senso (corona = monarchia).",
      lesson5Title: "5. Colora per categoria",
      lesson5Body: "Stesso colore = stesso tipo di informazione (cause, date, protagonisti). Il colore diventa un indizio di memoria.",
      lesson6Title: "6. Evidenzia il must-know",
      lesson6Body: "Alla fine evidenzia 3-5 nodi: sono quelli che ti salvano nella verifica. Ripassa partendo solo da quelli.",
      lesson7Title: "7. Ripeti a mappa coperta",
      lesson7Body: "Guarda la mappa 30 secondi, coprila e prova a ridisegnarla a memoria. È il ripasso più veloce che esista.",
    },
    sketch: {
      nodeTextLabel: "Testo del nodo",
      close: "Chiudi",
      notePlaceholder: "Nota breve (opzionale)",
      colorLabel: "Colore {{color}}",
      highlight: "Evidenzia",
      drawing: "Disegno",
      none: "no",
      addBranch: "Aggiungi ramo",
      delete: "Elimina",
      tapHint: "Tocca un elemento per modificarlo · trascinalo per spostarlo",
      newConcept: "Nuovo concetto",
    },
    map: {
      owl: "Gufo",
      fox: "Volpe",
    },
    download: {
      a4: "A4",
      a4Hint: "Standard",
      a3: "A3",
      a3Hint: "Grande",
      a5: "A5",
      a5Hint: "Piccolo",
      letter: "Letter",
      letterHint: "US",
      pdfReady: "PDF pronto",
      exportError: "Errore durante l'esportazione",
      downloadPdf: "Scarica PDF",
      paperFormat: "Formato foglio",
      orientation: "Orientamento",
      landscape: "Orizzontale",
      portrait: "Verticale",
      layout: "Layout",
      onePage: "Una pagina",
      onePageHint: "Adatta tutto",
      multiPage: "Multi-pagina",
      multiPageHint: "Mappe grandi, testo leggibile",
      generatingPdf: "Genero il PDF…",
      download: "Scarica",
    },
    player: {
      audioNotAvailable: "Audio non disponibile",
      preparingAudio: "Preparo l'audio…",
      downloadFailed: "Download non riuscito",
      dsaBadge: "DSA",
      continueVideo: "Continua il video",
      reviewPart: "Rivedi questa parte",
      subtitles: "Sottotitoli",
    },
    character: {
      isSpeaking: "{{name}} sta parlando",
      narrator: "Personaggio narratore",
    },
  },
  en: {
    presentation: {
      writeTopicError: "Write the presentation topic",
      generationFailed: "Generation failed",
      analysisFailed: "Analysis failed",
      micUnavailable: "Microphone not available",
      genericError: "Error",
      createTitle: "Create a presentation",
      topicLabel: "Topic",
      topicPlaceholder: "E.g. The French Revolution",
      sourceLabel: "Source material (optional)",
      sourcePlaceholder: "Paste notes or text to use as source",
      contextLabel: "Context",
      contextSchool: "School",
      contextUniversity: "University",
      contextExam: "Oral exam",
      contextMeeting: "Meeting",
      styleLabel: "Style",
      styleMinimal: "Minimal",
      styleNotebook: "Notebook",
      styleAcademic: "Academic",
      styleVisual: "Visual",
      styleDark: "Dark",
      durationLabel: "Duration: {{minutes}} minutes",
      extraLabel: "Extra requests (optional)",
      extraPlaceholder: "E.g. include a timeline",
      creatingSlides: "Creating slides...",
      generateButton: "Generate presentation",
      slideCount: "{{count}} slides · ~{{minutes}} min",
      newButton: "New",
      slideCounter: "Slide {{current}}/{{total}}",
      visualLabel: "Visual: {{visual}}",
      prevSlide: "Previous slide",
      nextSlide: "Next slide",
      speakSeconds: "{{seconds}}s of speech",
      whatToSay: "What to say",
      hide: "Hide",
      show: "Show",
      helpExposeTitle: "Help me present it",
      helpExposeDesc: "Record how you'd present this slide: I'll tell you what's missing and how to improve.",
      analyzing: "Analyzing...",
      stopAndAnalyze: "Stop and analyze",
      recordExposition: "Record your presentation",
      score: "Score: {{score}}/100",
      good: "Good",
      missing: "You missed",
      howToImprove: "How to improve",
      profQuestionsTitle: "Professor's questions",
      simulateQuestions: "Simulate questions",
      answerPlaceholder: "Your answer...",
      evaluate: "Evaluate",
      modelAnswer: "Model answer: {{answer}}",
    },
    illustrated: {
      genTab: "Generate",
      togetherTab: "Let's build it together",
      learnTab: "Learn",
      readFileError: "Unable to read the file",
      loginToSave: "You must log in to save",
      mapSaved: "Map saved to library",
      save: "Save",
      styleHandDrawnLabel: "Hand-drawn",
      styleHandDrawnHint: "Sketchnote with lots of drawings",
      styleNotebookLabel: "Notebook",
      styleNotebookHint: "Lined paper, handwriting",
      styleColorfulLabel: "Colorful",
      styleColorfulHint: "Colored branches, many icons",
      styleVisualLabel: "Super visual",
      styleVisualHint: "Few words, many symbols",
      styleKeywordsLabel: "Keywords",
      styleKeywordsHint: "Only essential keywords",
      styleDsaLabel: "SLD / test",
      styleDsaHint: "Maximum readability, only the essentials",
      styleMinimalLabel: "Minimal",
      styleMinimalHint: "Clean and sober",
      styleCleanLabel: "Tidy",
      styleCleanHint: "Clear with a few drawings",
      mapPending: "Illustrated map ready",
      materialUploaded: "Material uploaded",
      illustratedMapTitle: "Illustrated map",
      illustratedMapDesc: "Sketchnote style: the AI picks a small drawing for every concept worth remembering. You can edit texts, colors, symbols and move the branches.",
      topicLabel: "Topic",
      topicPlaceholder: "E.g. The French Revolution",
      styleLabel: "Style",
      materialOptionalLabel: "Material (optional)",
      materialPlaceholder: "Paste notes or a chapter…",
      textFile: "Text file",
      audioLesson: "Audio lesson",
      photoNotes: "Photo of notes",
      specialRequestLabel: "Special request (optional)",
      specialRequestPlaceholder: "E.g. only the causes, with drawings for the dates",
      createIllustratedMap: "Create illustrated map",
      askAiEdit: "Ask the AI for a change",
      askAiEditPlaceholder: "E.g. add a branch about the consequences",
      symbolHelperTitle: "What drawing should I make for…?",
      symbolHelperDesc: "Write a concept: the AI suggests the most effective symbols and explains why.",
      conceptPlaceholder: "E.g. inflation",
      guidedTitle: "Let's build it together",
      guidedDesc: "I won't give you the finished map: I'll guide you with one question at a time until you build it yourself. In the end you'll find it drawn and editable.",
      guidedTopicPlaceholder: "What are we talking about?",
      guidedStart: "Let's start",
      preparingFirstQuestion: "Preparing the first question…",
      stepLabel: "Step {{step}}",
      hintLabel: "Hint: {{hint}}",
      yourAnswerPlaceholder: "Your answer…",
      next: "Next",
      lessonEyebrow: "Learning how to learn",
      lessonTitle: "How to build a visual map",
      lessonDesc: "7 rules to apply in order. Try them on the next map you create.",
      lesson1Title: "1. Just one idea at the center",
      lesson1Body: "Write the topic in the center in 2-3 words and draw a symbol for it. The brain remembers much better when each concept has an image attached.",
      lesson2Title: "2. Branches = big questions",
      lesson2Body: "Each branch answers a question: what? why? when? consequences? Max 4-6 branches, otherwise it becomes a list.",
      lesson3Title: "3. Keywords, not sentences",
      lesson3Body: "One or two words per node. If you need a sentence, say it aloud when you review, don't write it.",
      lesson4Title: "4. Draw the meaning",
      lesson4Body: "You don't need to know how to draw: a heart, a crown, an arrow are enough. The symbol must represent the meaning (crown = monarchy).",
      lesson5Title: "5. Color by category",
      lesson5Body: "Same color = same type of information (causes, dates, protagonists). Color becomes a memory cue.",
      lesson6Title: "6. Highlight the must-know",
      lesson6Body: "At the end highlight 3-5 nodes: those are the ones that save you in the test. Review starting from those only.",
      lesson7Title: "7. Repeat with the map covered",
      lesson7Body: "Look at the map for 30 seconds, cover it and try to redraw it from memory. It's the fastest review there is.",
    },
    sketch: {
      nodeTextLabel: "Node text",
      close: "Close",
      notePlaceholder: "Short note (optional)",
      colorLabel: "Color {{color}}",
      highlight: "Highlight",
      drawing: "Drawing",
      none: "none",
      addBranch: "Add branch",
      delete: "Delete",
      tapHint: "Tap an item to edit it · drag it to move it",
      newConcept: "New concept",
    },
    map: {
      owl: "Owl",
      fox: "Fox",
    },
    download: {
      a4: "A4",
      a4Hint: "Standard",
      a3: "A3",
      a3Hint: "Large",
      a5: "A5",
      a5Hint: "Small",
      letter: "Letter",
      letterHint: "US",
      pdfReady: "PDF ready",
      exportError: "Error during export",
      downloadPdf: "Download PDF",
      paperFormat: "Paper format",
      orientation: "Orientation",
      landscape: "Landscape",
      portrait: "Portrait",
      layout: "Layout",
      onePage: "One page",
      onePageHint: "Fit everything",
      multiPage: "Multi-page",
      multiPageHint: "Large maps, readable text",
      generatingPdf: "Generating PDF…",
      download: "Download",
    },
    player: {
      audioNotAvailable: "Audio not available",
      preparingAudio: "Preparing audio…",
      downloadFailed: "Download failed",
      dsaBadge: "SLD",
      continueVideo: "Continue video",
      reviewPart: "Review this part",
      subtitles: "Subtitles",
    },
    character: {
      isSpeaking: "{{name}} is speaking",
      narrator: "Narrator character",
    },
  },
  es: {
    presentation: {
      writeTopicError: "Escribe el tema de la presentación",
      generationFailed: "Generación fallida",
      analysisFailed: "Análisis fallido",
      micUnavailable: "Micrófono no disponible",
      genericError: "Error",
      createTitle: "Crea una presentación",
      topicLabel: "Tema",
      topicPlaceholder: "Ej. La Revolución francesa",
      sourceLabel: "Material de partida (opcional)",
      sourcePlaceholder: "Pega apuntes o texto para usar como fuente",
      contextLabel: "Contexto",
      contextSchool: "Escuela",
      contextUniversity: "Universidad",
      contextExam: "Examen oral",
      contextMeeting: "Reunión",
      styleLabel: "Estilo",
      styleMinimal: "Minimal",
      styleNotebook: "Cuaderno",
      styleAcademic: "Académico",
      styleVisual: "Visual",
      styleDark: "Oscuro",
      durationLabel: "Duración: {{minutes}} minutos",
      extraLabel: "Peticiones extra (opcional)",
      extraPlaceholder: "Ej. incluye una línea de tiempo",
      creatingSlides: "Creando las diapositivas...",
      generateButton: "Generar presentación",
      slideCount: "{{count}} diapositivas · ~{{minutes}} min",
      newButton: "Nueva",
      slideCounter: "Diapositiva {{current}}/{{total}}",
      visualLabel: "Visual: {{visual}}",
      prevSlide: "Diapositiva anterior",
      nextSlide: "Diapositiva siguiente",
      speakSeconds: "{{seconds}}s de discurso",
      whatToSay: "Qué decir",
      hide: "Ocultar",
      show: "Mostrar",
      helpExposeTitle: "Ayúdame a exponerla",
      helpExposeDesc: "Graba cómo expondrías esta diapositiva: te digo qué falta y cómo mejorar.",
      analyzing: "Analizando...",
      stopAndAnalyze: "Detener y analizar",
      recordExposition: "Graba la exposición",
      score: "Puntuación: {{score}}/100",
      good: "Bien",
      missing: "Se te escapó",
      howToImprove: "Cómo mejorar",
      profQuestionsTitle: "Preguntas del profesor",
      simulateQuestions: "Simula las preguntas",
      answerPlaceholder: "Tu respuesta...",
      evaluate: "Evaluar",
      modelAnswer: "Respuesta modelo: {{answer}}",
    },
    illustrated: {
      genTab: "Generar",
      togetherTab: "Creémosla juntos",
      learnTab: "Aprender",
      readFileError: "No se pudo leer el archivo",
      loginToSave: "Debes iniciar sesión para guardar",
      mapSaved: "Mapa guardado en la biblioteca",
      save: "Guardar",
      styleHandDrawnLabel: "Dibujada a mano",
      styleHandDrawnHint: "Sketchnote con muchos dibujos",
      styleNotebookLabel: "Cuaderno",
      styleNotebookHint: "Hoja rayada, escritura a mano",
      styleColorfulLabel: "Colorida",
      styleColorfulHint: "Ramas de colores, muchos iconos",
      styleVisualLabel: "Súper visual",
      styleVisualHint: "Pocas palabras, muchos símbolos",
      styleKeywordsLabel: "Palabras clave",
      styleKeywordsHint: "Solo palabras clave esenciales",
      styleDsaLabel: "TDA / examen",
      styleDsaHint: "Máxima legibilidad, solo lo esencial",
      styleMinimalLabel: "Minimal",
      styleMinimalHint: "Limpia y sobria",
      styleCleanLabel: "Ordenada",
      styleCleanHint: "Clara con algún dibujo",
      mapPending: "Mapa ilustrado listo",
      materialUploaded: "Material cargado",
      illustratedMapTitle: "Mapa ilustrado",
      illustratedMapDesc: "Estilo sketchnote: la IA elige un pequeño dibujo para cada concepto que vale la pena recordar. Puedes modificar textos, colores, símbolos y mover las ramas.",
      topicLabel: "Tema",
      topicPlaceholder: "Ej. La revolución francesa",
      styleLabel: "Estilo",
      materialOptionalLabel: "Material (opcional)",
      materialPlaceholder: "Pega apuntes o un capítulo…",
      textFile: "Archivo de texto",
      audioLesson: "Audio de clase",
      photoNotes: "Foto de apuntes",
      specialRequestLabel: "Petición especial (opcional)",
      specialRequestPlaceholder: "Ej. solo las causas, con dibujos para las fechas",
      createIllustratedMap: "Crear mapa ilustrado",
      askAiEdit: "Pide un cambio a la IA",
      askAiEditPlaceholder: "Ej. añade una rama sobre las consecuencias",
      symbolHelperTitle: "¿Qué dibujo hago para…?",
      symbolHelperDesc: "Escribe un concepto: la IA propone los símbolos más eficaces y explica por qué.",
      conceptPlaceholder: "Ej. inflación",
      guidedTitle: "Creémosla juntos",
      guidedDesc: "No te doy el mapa ya hecho: te guío con una pregunta a la vez hasta que lo construyas tú. Al final lo encontrarás dibujado y editable.",
      guidedTopicPlaceholder: "¿De qué hablamos?",
      guidedStart: "Empecemos",
      preparingFirstQuestion: "Preparando la primera pregunta…",
      stepLabel: "Paso {{step}}",
      hintLabel: "Sugerencia: {{hint}}",
      yourAnswerPlaceholder: "Tu respuesta…",
      next: "Siguiente",
      lessonEyebrow: "Aprender a aprender",
      lessonTitle: "Cómo se construye un mapa visual",
      lessonDesc: "7 reglas a aplicar en orden. Pruébalas en el próximo mapa que crees.",
      lesson1Title: "1. Una sola idea en el centro",
      lesson1Body: "Escribe en el centro el tema en 2-3 palabras y dibuja un símbolo. El cerebro recuerda mucho mejor si cada concepto tiene una imagen asociada.",
      lesson2Title: "2. Ramas = grandes preguntas",
      lesson2Body: "Cada rama responde a una pregunta: ¿qué? ¿por qué? ¿cuándo? ¿consecuencias? Máximo 4-6 ramas, si no se convierte en una lista.",
      lesson3Title: "3. Palabras clave, no frases",
      lesson3Body: "Una o dos palabras por nodo. Si necesitas una frase, dila en voz alta al repasar, no la escribas.",
      lesson4Title: "4. Dibuja el significado",
      lesson4Body: "No hace falta saber dibujar: un corazón, una corona, una flecha bastan. El símbolo debe representar el sentido (corona = monarquía).",
      lesson5Title: "5. Colorea por categoría",
      lesson5Body: "Mismo color = mismo tipo de información (causas, fechas, protagonistas). El color se convierte en una pista de memoria.",
      lesson6Title: "6. Resalta lo imprescindible",
      lesson6Body: "Al final resalta 3-5 nodos: son los que te salvan en el examen. Repasa empezando solo por esos.",
      lesson7Title: "7. Repite con el mapa tapado",
      lesson7Body: "Mira el mapa 30 segundos, tápalo e intenta redibujarlo de memoria. Es el repaso más rápido que existe.",
    },
    sketch: {
      nodeTextLabel: "Texto del nodo",
      close: "Cerrar",
      notePlaceholder: "Nota breve (opcional)",
      colorLabel: "Color {{color}}",
      highlight: "Resaltar",
      drawing: "Dibujo",
      none: "ninguno",
      addBranch: "Añadir rama",
      delete: "Eliminar",
      tapHint: "Toca un elemento para editarlo · arrástralo para moverlo",
      newConcept: "Nuevo concepto",
    },
    map: {
      owl: "Búho",
      fox: "Zorro",
    },
    download: {
      a4: "A4",
      a4Hint: "Estándar",
      a3: "A3",
      a3Hint: "Grande",
      a5: "A5",
      a5Hint: "Pequeño",
      letter: "Letter",
      letterHint: "US",
      pdfReady: "PDF listo",
      exportError: "Error durante la exportación",
      downloadPdf: "Descargar PDF",
      paperFormat: "Formato de papel",
      orientation: "Orientación",
      landscape: "Horizontal",
      portrait: "Vertical",
      layout: "Diseño",
      onePage: "Una página",
      onePageHint: "Ajusta todo",
      multiPage: "Multi-página",
      multiPageHint: "Mapas grandes, texto legible",
      generatingPdf: "Generando el PDF…",
      download: "Descargar",
    },
    player: {
      audioNotAvailable: "Audio no disponible",
      preparingAudio: "Preparando el audio…",
      downloadFailed: "Descarga fallida",
      dsaBadge: "TDA",
      continueVideo: "Continuar vídeo",
      reviewPart: "Repasa esta parte",
      subtitles: "Subtítulos",
    },
    character: {
      isSpeaking: "{{name}} está hablando",
      narrator: "Personaje narrador",
    },
  },
  fr: {
    presentation: {
      writeTopicError: "Écris le sujet de la présentation",
      generationFailed: "Échec de la génération",
      analysisFailed: "Échec de l'analyse",
      micUnavailable: "Microphone non disponible",
      genericError: "Erreur",
      createTitle: "Crée une présentation",
      topicLabel: "Sujet",
      topicPlaceholder: "Ex. La Révolution française",
      sourceLabel: "Matériel de départ (facultatif)",
      sourcePlaceholder: "Colle des notes ou du texte à utiliser comme source",
      contextLabel: "Contexte",
      contextSchool: "École",
      contextUniversity: "Université",
      contextExam: "Examen oral",
      contextMeeting: "Réunion",
      styleLabel: "Style",
      styleMinimal: "Minimal",
      styleNotebook: "Cahier",
      styleAcademic: "Académique",
      styleVisual: "Visuel",
      styleDark: "Sombre",
      durationLabel: "Durée : {{minutes}} minutes",
      extraLabel: "Demandes supplémentaires (facultatif)",
      extraPlaceholder: "Ex. inclure une chronologie",
      creatingSlides: "Création des diapositives...",
      generateButton: "Générer la présentation",
      slideCount: "{{count}} diapositives · ~{{minutes}} min",
      newButton: "Nouvelle",
      slideCounter: "Diapositive {{current}}/{{total}}",
      visualLabel: "Visuel : {{visual}}",
      prevSlide: "Diapositive précédente",
      nextSlide: "Diapositive suivante",
      speakSeconds: "{{seconds}}s de parole",
      whatToSay: "Quoi dire",
      hide: "Masquer",
      show: "Afficher",
      helpExposeTitle: "Aide-moi à la présenter",
      helpExposeDesc: "Enregistre comment tu présenterais cette diapositive : je te dis ce qui manque et comment t'améliorer.",
      analyzing: "Analyse en cours...",
      stopAndAnalyze: "Arrêter et analyser",
      recordExposition: "Enregistre ta présentation",
      score: "Score : {{score}}/100",
      good: "Bien",
      missing: "Tu as manqué",
      howToImprove: "Comment s'améliorer",
      profQuestionsTitle: "Questions du prof",
      simulateQuestions: "Simuler les questions",
      answerPlaceholder: "Ta réponse...",
      evaluate: "Évaluer",
      modelAnswer: "Réponse modèle : {{answer}}",
    },
    illustrated: {
      genTab: "Générer",
      togetherTab: "Créons-la ensemble",
      learnTab: "Apprendre",
      readFileError: "Impossible de lire le fichier",
      loginToSave: "Tu dois te connecter pour enregistrer",
      mapSaved: "Carte enregistrée dans la bibliothèque",
      save: "Enregistrer",
      styleHandDrawnLabel: "Dessinée à la main",
      styleHandDrawnHint: "Sketchnote avec beaucoup de dessins",
      styleNotebookLabel: "Cahier",
      styleNotebookHint: "Feuille lignée, écriture manuscrite",
      styleColorfulLabel: "Colorée",
      styleColorfulHint: "Branches colorées, beaucoup d'icônes",
      styleVisualLabel: "Super visuelle",
      styleVisualHint: "Peu de mots, beaucoup de symboles",
      styleKeywordsLabel: "Mots-clés",
      styleKeywordsHint: "Uniquement les mots-clés essentiels",
      styleDsaLabel: "TSA / contrôle",
      styleDsaHint: "Lisibilité maximale, seulement l'essentiel",
      styleMinimalLabel: "Minimal",
      styleMinimalHint: "Propre et sobre",
      styleCleanLabel: "Ordonnée",
      styleCleanHint: "Claire avec quelques dessins",
      mapPending: "Carte illustrée prête",
      materialUploaded: "Matériel téléchargé",
      illustratedMapTitle: "Carte illustrée",
      illustratedMapDesc: "Style sketchnote : l'IA choisit un petit dessin pour chaque concept qui vaut la peine d'être retenu. Tu peux modifier les textes, les couleurs, les symboles et déplacer les branches.",
      topicLabel: "Sujet",
      topicPlaceholder: "Ex. La révolution française",
      styleLabel: "Style",
      materialOptionalLabel: "Matériel (facultatif)",
      materialPlaceholder: "Colle des notes ou un chapitre…",
      textFile: "Fichier texte",
      audioLesson: "Cours audio",
      photoNotes: "Photo de notes",
      specialRequestLabel: "Demande particulière (facultatif)",
      specialRequestPlaceholder: "Ex. seulement les causes, avec des dessins pour les dates",
      createIllustratedMap: "Créer une carte illustrée",
      askAiEdit: "Demander une modification à l'IA",
      askAiEditPlaceholder: "Ex. ajoute une branche sur les conséquences",
      symbolHelperTitle: "Quel dessin faire pour… ?",
      symbolHelperDesc: "Écris un concept : l'IA propose les symboles les plus efficaces et explique pourquoi.",
      conceptPlaceholder: "Ex. inflation",
      guidedTitle: "Créons-la ensemble",
      guidedDesc: "Je ne te donne pas la carte déjà faite : je te guide avec une question à la fois jusqu'à ce que tu la construises toi-même. À la fin, tu la trouveras dessinée et modifiable.",
      guidedTopicPlaceholder: "De quoi parle-t-on ?",
      guidedStart: "Commençons",
      preparingFirstQuestion: "Préparation de la première question…",
      stepLabel: "Étape {{step}}",
      hintLabel: "Astuce : {{hint}}",
      yourAnswerPlaceholder: "Ta réponse…",
      next: "Suivant",
      lessonEyebrow: "Apprendre à apprendre",
      lessonTitle: "Comment construire une carte visuelle",
      lessonDesc: "7 règles à appliquer dans l'ordre. Essaie-les sur la prochaine carte que tu crées.",
      lesson1Title: "1. Une seule idée au centre",
      lesson1Body: "Écris au centre le sujet en 2-3 mots et dessine un symbole. Le cerveau se souvient bien mieux quand chaque concept a une image associée.",
      lesson2Title: "2. Branches = grandes questions",
      lesson2Body: "Chaque branche répond à une question : quoi ? pourquoi ? quand ? conséquences ? Maximum 4-6 branches, sinon ça devient une liste.",
      lesson3Title: "3. Mots-clés, pas de phrases",
      lesson3Body: "Un ou deux mots par nœud. Si tu as besoin d'une phrase, dis-la à voix haute en révisant, ne l'écris pas.",
      lesson4Title: "4. Dessine le sens",
      lesson4Body: "Pas besoin de savoir dessiner : un cœur, une couronne, une flèche suffisent. Le symbole doit représenter le sens (couronne = monarchie).",
      lesson5Title: "5. Colore par catégorie",
      lesson5Body: "Même couleur = même type d'information (causes, dates, protagonistes). La couleur devient un indice de mémoire.",
      lesson6Title: "6. Surligne l'essentiel",
      lesson6Body: "À la fin, surligne 3-5 nœuds : ce sont ceux qui te sauvent au contrôle. Révise en partant uniquement de ceux-là.",
      lesson7Title: "7. Répète la carte cachée",
      lesson7Body: "Regarde la carte 30 secondes, cache-la et essaie de la redessiner de mémoire. C'est la révision la plus rapide qui existe.",
    },
    sketch: {
      nodeTextLabel: "Texte du nœud",
      close: "Fermer",
      notePlaceholder: "Note courte (facultatif)",
      colorLabel: "Couleur {{color}}",
      highlight: "Surligner",
      drawing: "Dessin",
      none: "aucun",
      addBranch: "Ajouter une branche",
      delete: "Supprimer",
      tapHint: "Touche un élément pour le modifier · fais-le glisser pour le déplacer",
      newConcept: "Nouveau concept",
    },
    map: {
      owl: "Hibou",
      fox: "Renard",
    },
    download: {
      a4: "A4",
      a4Hint: "Standard",
      a3: "A3",
      a3Hint: "Grand",
      a5: "A5",
      a5Hint: "Petit",
      letter: "Letter",
      letterHint: "US",
      pdfReady: "PDF prêt",
      exportError: "Erreur pendant l'exportation",
      downloadPdf: "Télécharger le PDF",
      paperFormat: "Format de papier",
      orientation: "Orientation",
      landscape: "Paysage",
      portrait: "Portrait",
      layout: "Mise en page",
      onePage: "Une page",
      onePageHint: "Tout adapter",
      multiPage: "Multi-page",
      multiPageHint: "Grandes cartes, texte lisible",
      generatingPdf: "Génération du PDF…",
      download: "Télécharger",
    },
    player: {
      audioNotAvailable: "Audio non disponible",
      preparingAudio: "Préparation de l'audio…",
      downloadFailed: "Téléchargement échoué",
      dsaBadge: "TSA",
      continueVideo: "Continuer la vidéo",
      reviewPart: "Revoir cette partie",
      subtitles: "Sous-titres",
    },
    character: {
      isSpeaking: "{{name}} est en train de parler",
      narrator: "Personnage narrateur",
    },
  },
  de: {
    presentation: {
      writeTopicError: "Schreibe das Thema der Präsentation",
      generationFailed: "Erstellung fehlgeschlagen",
      analysisFailed: "Analyse fehlgeschlagen",
      micUnavailable: "Mikrofon nicht verfügbar",
      genericError: "Fehler",
      createTitle: "Erstelle eine Präsentation",
      topicLabel: "Thema",
      topicPlaceholder: "Z. B. Die Französische Revolution",
      sourceLabel: "Ausgangsmaterial (optional)",
      sourcePlaceholder: "Füge Notizen oder Text als Quelle ein",
      contextLabel: "Kontext",
      contextSchool: "Schule",
      contextUniversity: "Universität",
      contextExam: "Mündliche Prüfung",
      contextMeeting: "Meeting",
      styleLabel: "Stil",
      styleMinimal: "Minimal",
      styleNotebook: "Notizbuch",
      styleAcademic: "Akademisch",
      styleVisual: "Visuell",
      styleDark: "Dunkel",
      durationLabel: "Dauer: {{minutes}} Minuten",
      extraLabel: "Zusätzliche Wünsche (optional)",
      extraPlaceholder: "Z. B. eine Zeitleiste einfügen",
      creatingSlides: "Erstelle die Folien...",
      generateButton: "Präsentation erstellen",
      slideCount: "{{count}} Folien · ~{{minutes}} Min.",
      newButton: "Neu",
      slideCounter: "Folie {{current}}/{{total}}",
      visualLabel: "Visuell: {{visual}}",
      prevSlide: "Vorherige Folie",
      nextSlide: "Nächste Folie",
      speakSeconds: "{{seconds}}s Sprechzeit",
      whatToSay: "Was zu sagen ist",
      hide: "Ausblenden",
      show: "Anzeigen",
      helpExposeTitle: "Hilf mir, sie vorzutragen",
      helpExposeDesc: "Nimm auf, wie du diese Folie vortragen würdest: Ich sage dir, was fehlt und wie du dich verbessern kannst.",
      analyzing: "Analysiere...",
      stopAndAnalyze: "Stoppen und analysieren",
      recordExposition: "Vortrag aufnehmen",
      score: "Punktzahl: {{score}}/100",
      good: "Gut",
      missing: "Dir ist entgangen",
      howToImprove: "Wie man sich verbessert",
      profQuestionsTitle: "Fragen des Professors",
      simulateQuestions: "Fragen simulieren",
      answerPlaceholder: "Deine Antwort...",
      evaluate: "Bewerten",
      modelAnswer: "Musterantwort: {{answer}}",
    },
    illustrated: {
      genTab: "Erstellen",
      togetherTab: "Gemeinsam erstellen",
      learnTab: "Lernen",
      readFileError: "Datei konnte nicht gelesen werden",
      loginToSave: "Du musst dich anmelden, um zu speichern",
      mapSaved: "Karte in der Bibliothek gespeichert",
      save: "Speichern",
      styleHandDrawnLabel: "Handgezeichnet",
      styleHandDrawnHint: "Sketchnote mit vielen Zeichnungen",
      styleNotebookLabel: "Notizbuch",
      styleNotebookHint: "Liniertes Blatt, Handschrift",
      styleColorfulLabel: "Bunt",
      styleColorfulHint: "Farbige Äste, viele Symbole",
      styleVisualLabel: "Super visuell",
      styleVisualHint: "Wenige Wörter, viele Symbole",
      styleKeywordsLabel: "Schlüsselwörter",
      styleKeywordsHint: "Nur die wichtigsten Schlüsselwörter",
      styleDsaLabel: "LRS / Test",
      styleDsaHint: "Maximale Lesbarkeit, nur das Wesentliche",
      styleMinimalLabel: "Minimal",
      styleMinimalHint: "Klar und schlicht",
      styleCleanLabel: "Ordentlich",
      styleCleanHint: "Klar mit einigen Zeichnungen",
      mapPending: "Illustrierte Karte fertig",
      materialUploaded: "Material hochgeladen",
      illustratedMapTitle: "Illustrierte Karte",
      illustratedMapDesc: "Sketchnote-Stil: Die KI wählt eine kleine Zeichnung für jedes Konzept, das man sich merken sollte. Du kannst Texte, Farben, Symbole ändern und die Äste verschieben.",
      topicLabel: "Thema",
      topicPlaceholder: "Z. B. Die Französische Revolution",
      styleLabel: "Stil",
      materialOptionalLabel: "Material (optional)",
      materialPlaceholder: "Füge Notizen oder ein Kapitel ein…",
      textFile: "Textdatei",
      audioLesson: "Audiostunde",
      photoNotes: "Foto von Notizen",
      specialRequestLabel: "Besonderer Wunsch (optional)",
      specialRequestPlaceholder: "Z. B. nur die Ursachen, mit Zeichnungen für die Daten",
      createIllustratedMap: "Illustrierte Karte erstellen",
      askAiEdit: "KI um eine Änderung bitten",
      askAiEditPlaceholder: "Z. B. füge einen Ast über die Folgen hinzu",
      symbolHelperTitle: "Welche Zeichnung mache ich für…?",
      symbolHelperDesc: "Schreibe ein Konzept: Die KI schlägt die effektivsten Symbole vor und erklärt warum.",
      conceptPlaceholder: "Z. B. Inflation",
      guidedTitle: "Gemeinsam erstellen",
      guidedDesc: "Ich gebe dir nicht die fertige Karte: Ich führe dich mit einer Frage nach der anderen, bis du sie selbst erstellst. Am Ende findest du sie gezeichnet und bearbeitbar.",
      guidedTopicPlaceholder: "Worüber sprechen wir?",
      guidedStart: "Los geht's",
      preparingFirstQuestion: "Bereite die erste Frage vor…",
      stepLabel: "Schritt {{step}}",
      hintLabel: "Tipp: {{hint}}",
      yourAnswerPlaceholder: "Deine Antwort…",
      next: "Weiter",
      lessonEyebrow: "Lernen zu lernen",
      lessonTitle: "Wie man eine visuelle Karte erstellt",
      lessonDesc: "7 Regeln, die du der Reihe nach anwenden solltest. Probiere sie bei der nächsten Karte aus, die du erstellst.",
      lesson1Title: "1. Nur eine Idee im Zentrum",
      lesson1Body: "Schreibe das Thema mit 2-3 Wörtern in die Mitte und zeichne ein Symbol dazu. Das Gehirn erinnert sich viel besser, wenn jedes Konzept ein Bild hat.",
      lesson2Title: "2. Äste = große Fragen",
      lesson2Body: "Jeder Ast beantwortet eine Frage: was? warum? wann? Folgen? Maximal 4-6 Äste, sonst wird es eine Liste.",
      lesson3Title: "3. Schlüsselwörter, keine Sätze",
      lesson3Body: "Ein oder zwei Wörter pro Knoten. Wenn du einen Satz brauchst, sag ihn beim Wiederholen laut, schreib ihn nicht auf.",
      lesson4Title: "4. Zeichne die Bedeutung",
      lesson4Body: "Man muss nicht zeichnen können: ein Herz, eine Krone, ein Pfeil reichen. Das Symbol muss die Bedeutung darstellen (Krone = Monarchie).",
      lesson5Title: "5. Farbe nach Kategorie",
      lesson5Body: "Gleiche Farbe = gleicher Informationstyp (Ursachen, Daten, Protagonisten). Die Farbe wird zu einem Gedächtnishinweis.",
      lesson6Title: "6. Hebe das Wichtigste hervor",
      lesson6Body: "Markiere am Ende 3-5 Knoten: das sind die, die dich bei der Prüfung retten. Wiederhole nur ausgehend von diesen.",
      lesson7Title: "7. Mit verdeckter Karte wiederholen",
      lesson7Body: "Schau dir die Karte 30 Sekunden an, decke sie zu und versuche, sie aus dem Gedächtnis neu zu zeichnen. Das ist die schnellste Wiederholung, die es gibt.",
    },
    sketch: {
      nodeTextLabel: "Knotentext",
      close: "Schließen",
      notePlaceholder: "Kurze Notiz (optional)",
      colorLabel: "Farbe {{color}}",
      highlight: "Hervorheben",
      drawing: "Zeichnung",
      none: "keine",
      addBranch: "Ast hinzufügen",
      delete: "Löschen",
      tapHint: "Tippe auf ein Element, um es zu bearbeiten · ziehe es, um es zu verschieben",
      newConcept: "Neues Konzept",
    },
    map: {
      owl: "Eule",
      fox: "Fuchs",
    },
    download: {
      a4: "A4",
      a4Hint: "Standard",
      a3: "A3",
      a3Hint: "Groß",
      a5: "A5",
      a5Hint: "Klein",
      letter: "Letter",
      letterHint: "US",
      pdfReady: "PDF bereit",
      exportError: "Fehler beim Export",
      downloadPdf: "PDF herunterladen",
      paperFormat: "Papierformat",
      orientation: "Ausrichtung",
      landscape: "Querformat",
      portrait: "Hochformat",
      layout: "Layout",
      onePage: "Eine Seite",
      onePageHint: "Alles anpassen",
      multiPage: "Mehrseitig",
      multiPageHint: "Große Karten, lesbarer Text",
      generatingPdf: "PDF wird erstellt…",
      download: "Herunterladen",
    },
    player: {
      audioNotAvailable: "Audio nicht verfügbar",
      preparingAudio: "Audio wird vorbereitet…",
      downloadFailed: "Download fehlgeschlagen",
      dsaBadge: "LRS",
      continueVideo: "Video fortsetzen",
      reviewPart: "Diesen Teil wiederholen",
      subtitles: "Untertitel",
    },
    character: {
      isSpeaking: "{{name}} spricht",
      narrator: "Erzählerfigur",
    },
  },
  pt: {
    presentation: {
      writeTopicError: "Escreve o tema da apresentação",
      generationFailed: "Geração falhou",
      analysisFailed: "Análise falhou",
      micUnavailable: "Microfone não disponível",
      genericError: "Erro",
      createTitle: "Cria uma apresentação",
      topicLabel: "Tema",
      topicPlaceholder: "Ex. A Revolução Francesa",
      sourceLabel: "Material de partida (opcional)",
      sourcePlaceholder: "Cola notas ou texto para usar como fonte",
      contextLabel: "Contexto",
      contextSchool: "Escola",
      contextUniversity: "Universidade",
      contextExam: "Exame oral",
      contextMeeting: "Reunião",
      styleLabel: "Estilo",
      styleMinimal: "Minimal",
      styleNotebook: "Caderno",
      styleAcademic: "Académico",
      styleVisual: "Visual",
      styleDark: "Escuro",
      durationLabel: "Duração: {{minutes}} minutos",
      extraLabel: "Pedidos extra (opcional)",
      extraPlaceholder: "Ex. inclui uma linha do tempo",
      creatingSlides: "A criar os slides...",
      generateButton: "Gerar apresentação",
      slideCount: "{{count}} slides · ~{{minutes}} min",
      newButton: "Nova",
      slideCounter: "Slide {{current}}/{{total}}",
      visualLabel: "Visual: {{visual}}",
      prevSlide: "Slide anterior",
      nextSlide: "Slide seguinte",
      speakSeconds: "{{seconds}}s de fala",
      whatToSay: "O que dizer",
      hide: "Ocultar",
      show: "Mostrar",
      helpExposeTitle: "Ajuda-me a apresentá-la",
      helpExposeDesc: "Grava como apresentarias este slide: digo-te o que falta e como melhorar.",
      analyzing: "A analisar...",
      stopAndAnalyze: "Parar e analisar",
      recordExposition: "Grava a apresentação",
      score: "Pontuação: {{score}}/100",
      good: "Bem",
      missing: "Falhaste",
      howToImprove: "Como melhorar",
      profQuestionsTitle: "Perguntas do professor",
      simulateQuestions: "Simular perguntas",
      answerPlaceholder: "A tua resposta...",
      evaluate: "Avaliar",
      modelAnswer: "Resposta modelo: {{answer}}",
    },
    illustrated: {
      genTab: "Gerar",
      togetherTab: "Vamos criá-la juntos",
      learnTab: "Aprender",
      readFileError: "Não foi possível ler o ficheiro",
      loginToSave: "Tens de iniciar sessão para guardar",
      mapSaved: "Mapa guardado na biblioteca",
      save: "Guardar",
      styleHandDrawnLabel: "Desenhada à mão",
      styleHandDrawnHint: "Sketchnote com muitos desenhos",
      styleNotebookLabel: "Caderno",
      styleNotebookHint: "Folha pautada, escrita à mão",
      styleColorfulLabel: "Colorida",
      styleColorfulHint: "Ramos coloridos, muitos ícones",
      styleVisualLabel: "Super visual",
      styleVisualHint: "Poucas palavras, muitos símbolos",
      styleKeywordsLabel: "Palavras-chave",
      styleKeywordsHint: "Apenas palavras-chave essenciais",
      styleDsaLabel: "PEA / teste",
      styleDsaHint: "Máxima legibilidade, apenas o essencial",
      styleMinimalLabel: "Minimal",
      styleMinimalHint: "Limpa e sóbria",
      styleCleanLabel: "Organizada",
      styleCleanHint: "Clara com alguns desenhos",
      mapPending: "Mapa ilustrado pronto",
      materialUploaded: "Material carregado",
      illustratedMapTitle: "Mapa ilustrado",
      illustratedMapDesc: "Estilo sketchnote: a IA escolhe um pequeno desenho para cada conceito que vale a pena lembrar. Podes modificar textos, cores, símbolos e mover os ramos.",
      topicLabel: "Tema",
      topicPlaceholder: "Ex. A revolução francesa",
      styleLabel: "Estilo",
      materialOptionalLabel: "Material (opcional)",
      materialPlaceholder: "Cola notas ou um capítulo…",
      textFile: "Ficheiro de texto",
      audioLesson: "Aula em áudio",
      photoNotes: "Foto de notas",
      specialRequestLabel: "Pedido especial (opcional)",
      specialRequestPlaceholder: "Ex. só as causas, com desenhos para as datas",
      createIllustratedMap: "Criar mapa ilustrado",
      askAiEdit: "Pedir uma alteração à IA",
      askAiEditPlaceholder: "Ex. adiciona um ramo sobre as consequências",
      symbolHelperTitle: "Que desenho faço para…?",
      symbolHelperDesc: "Escreve um conceito: a IA propõe os símbolos mais eficazes e explica porquê.",
      conceptPlaceholder: "Ex. inflação",
      guidedTitle: "Vamos criá-la juntos",
      guidedDesc: "Não te dou o mapa já feito: guio-te com uma pergunta de cada vez até tu próprio o construíres. No final vais encontrá-lo desenhado e editável.",
      guidedTopicPlaceholder: "Sobre o que vamos falar?",
      guidedStart: "Vamos começar",
      preparingFirstQuestion: "A preparar a primeira pergunta…",
      stepLabel: "Passo {{step}}",
      hintLabel: "Sugestão: {{hint}}",
      yourAnswerPlaceholder: "A tua resposta…",
      next: "Seguinte",
      lessonEyebrow: "Aprender a aprender",
      lessonTitle: "Como se constrói um mapa visual",
      lessonDesc: "7 regras para aplicar em ordem. Experimenta-as no próximo mapa que criares.",
      lesson1Title: "1. Uma só ideia no centro",
      lesson1Body: "Escreve no centro o tema em 2-3 palavras e desenha um símbolo. O cérebro recorda muito melhor quando cada conceito tem uma imagem associada.",
      lesson2Title: "2. Ramos = grandes perguntas",
      lesson2Body: "Cada ramo responde a uma pergunta: o quê? porquê? quando? consequências? Máximo 4-6 ramos, senão torna-se uma lista.",
      lesson3Title: "3. Palavras-chave, não frases",
      lesson3Body: "Uma ou duas palavras por nó. Se precisares de uma frase, di-la em voz alta ao rever, não a escrevas.",
      lesson4Title: "4. Desenha o significado",
      lesson4Body: "Não precisas de saber desenhar: um coração, uma coroa, uma seta bastam. O símbolo deve representar o sentido (coroa = monarquia).",
      lesson5Title: "5. Colore por categoria",
      lesson5Body: "Mesma cor = mesmo tipo de informação (causas, datas, protagonistas). A cor torna-se uma pista de memória.",
      lesson6Title: "6. Destaca o essencial",
      lesson6Body: "No final destaca 3-5 nós: são os que te salvam no teste. Revê começando só por esses.",
      lesson7Title: "7. Repete com o mapa tapado",
      lesson7Body: "Olha para o mapa 30 segundos, tapa-o e tenta redesenhá-lo de memória. É a revisão mais rápida que existe.",
    },
    sketch: {
      nodeTextLabel: "Texto do nó",
      close: "Fechar",
      notePlaceholder: "Nota breve (opcional)",
      colorLabel: "Cor {{color}}",
      highlight: "Destacar",
      drawing: "Desenho",
      none: "nenhum",
      addBranch: "Adicionar ramo",
      delete: "Eliminar",
      tapHint: "Toca num elemento para o editar · arrasta-o para o mover",
      newConcept: "Novo conceito",
    },
    map: {
      owl: "Coruja",
      fox: "Raposa",
    },
    download: {
      a4: "A4",
      a4Hint: "Padrão",
      a3: "A3",
      a3Hint: "Grande",
      a5: "A5",
      a5Hint: "Pequeno",
      letter: "Letter",
      letterHint: "US",
      pdfReady: "PDF pronto",
      exportError: "Erro durante a exportação",
      downloadPdf: "Descarregar PDF",
      paperFormat: "Formato de papel",
      orientation: "Orientação",
      landscape: "Horizontal",
      portrait: "Vertical",
      layout: "Layout",
      onePage: "Uma página",
      onePageHint: "Ajusta tudo",
      multiPage: "Multi-página",
      multiPageHint: "Mapas grandes, texto legível",
      generatingPdf: "A gerar o PDF…",
      download: "Descarregar",
    },
    player: {
      audioNotAvailable: "Áudio não disponível",
      preparingAudio: "A preparar o áudio…",
      downloadFailed: "Falha na transferência",
      dsaBadge: "PEA",
      continueVideo: "Continuar o vídeo",
      reviewPart: "Rever esta parte",
      subtitles: "Legendas",
    },
    character: {
      isSpeaking: "{{name}} está a falar",
      narrator: "Personagem narrador",
    },
  },
};
